import { useState } from 'react';
import { formatToolRaw, summarizeToolCall } from './tool-presentation';
import type { ThreadToolCall } from './thread';
import { MarkdownPreview } from '../ui/MarkdownPreview';

export function ToolCallCard({ item }: { item: ThreadToolCall }) {
  const [expanded, setExpanded] = useState(false);
  const [showRaw, setShowRaw] = useState(false);
  const presentation = summarizeToolCall(item.toolName, item.input);
  const raw = [formatToolRaw(item.input), formatToolRaw(item.output)].filter(Boolean).join('\n\n');
  return (
    <div className="text-sm" data-pending={item.pending ? 'true' : undefined}>
      <button type="button" className="flex w-full items-center gap-2 rounded-md px-1.5 py-1 text-left text-gray-600" onClick={() => { setExpanded((value) => !value); if (expanded) setShowRaw(false); }} data-testid={`tool-card-${item.id}`}>
        <span className="min-w-0 flex-1 truncate font-medium">{presentation.summary}</span>
        {item.pending && <span className="text-[11px] text-gray-400">running...</span>}
      </button>
      {expanded && (
        <div className="ml-5 mt-0.5 space-y-2 border-l border-gray-200 py-1 pl-3 dark:border-gray-700">
          {presentation.keyFields.map((field) => (
            <div key={field.key} className="text-xs"><span className="text-gray-400">{field.label}</span> <code>{field.value}</code></div>
          ))}
          {item.output && <MarkdownPreview content={item.output} />}
          {item.truncated && <div className="text-[11px] italic text-gray-400">Preview truncated. The full result is in the run work log.</div>}
          <button type="button" className="text-[11px] text-gray-400 underline" data-testid={`tool-card-raw-${item.id}`} onClick={(event) => { event.stopPropagation(); setShowRaw((value) => !value); }}>{showRaw ? 'Hide raw' : 'View raw'}</button>
          {showRaw && <pre className="mt-1 max-h-48 overflow-auto whitespace-pre-wrap text-[11px]">{raw}</pre>}
        </div>
      )}
    </div>
  );
}
